import { Menu } from "lucide-react";
import logoMain from "assets/images/logos/logo-main.svg";
import logoConfiancia from "assets/images/logos/logo-main-simple.svg";
import { useMenuLogo } from "./useMenuLogo";

export const DashboardMenuLogo: React.FC<{
  isCollapsed: boolean;
  onToggle: () => void;
}> = ({ isCollapsed, onToggle }) => {
  const { logo } = useMenuLogo()

  return (
    <div
      className={`absolute
    ${isCollapsed ? 'w-24 h-24' : 'w-max -left-2.5 -top-2.5'}
`}
    >
      {/* Logos complets quand le menu est ouvert */}
      {!isCollapsed && (
        <>
          <img
            className="w-full h-full object-contain block max-w-full"
            src={logoMain}
            alt="logo"
          />
          {logo != null && (
            <img
              className="absolute cursor-pointer top-2.5 left-5 max-w-52 max-h-20 w-full h-full object-contain"
              onClick={onToggle}
              src={logo !== "" ? logo : logoConfiancia}
              alt="logo complet"
            />
          )}
        </>
      )}
      {/* Icône seule quand le menu est fermé */}
      {isCollapsed && (
        <div className="cursor-pointer text-white/70 hover:text-white h-full flex items-center justify-center"
          onClick={onToggle}
        >
          <Menu size={24} className="text-current" />
        </div>
      )}
    </div>
  );
};
